document.addEventListener('DOMContentLoaded', function () {
  // トップページだけ
  if (!document.body.classList.contains('template-index')) return;

  const instaIcons = document.querySelectorAll('.insta-icon');
  if (!instaIcons.length) return;

  function setWhite() {
    instaIcons.forEach(function (img) {
      img.style.filter = 'invert(1) brightness(2)'; // 白っぽく
    });
  }

  function setBlack() {
    instaIcons.forEach(function (img) {
      img.style.filter = 'none'; // 黒
    });
  }

  function updateIconColor() {
    const scrollTop =
      window.scrollY || document.documentElement.scrollTop || 0;

    // ★ ここで「PC幅かどうか」を判定（例：768px以上をPC扱い）
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;

    // ---- モバイル処理 ----
    if (!isDesktop) {
      // モバイルのときは、常に黒に固定
      setBlack();
      return; // ここで終わり（スクロール判定などはPCだけ）
    }

    // ---- ここからPC処理 ----
    const isStuck =
      document.body.classList.contains('header-stuck') ||
      document.querySelector('.header-stuck') !== null;

    // ほぼ一番上（10px未満）なら、header-stuck が付いていても白にする
    if (scrollTop < 10) {
      setWhite();
    } else if (isStuck) {
      // スクロールしてヘッダーがくっついたあたりから黒
      setBlack();
    } else {
      // それ以外は白
      setWhite();
    }
  }

  // 初期表示
  updateIconColor();

  // スクロールごとにチェック
  window.addEventListener('scroll', updateIconColor);

  // 画面幅を変えたとき（PC↔SP）も念のため更新
  window.addEventListener('resize', updateIconColor);
});

document.addEventListener('DOMContentLoaded', function () {


  const section = document.querySelector('.home-carousel');


  if (!section) return;

  const heroCarousel = section;


  let timer = null;

  function getSlides() {
    return Array.from(heroCarousel.querySelectorAll('media-carousel-slide.swiper-slide'));
  }

  function getActiveSlide() {
    const slides = getSlides();
    if (!slides.length) return null;

    let active = heroCarousel.querySelector('media-carousel-slide.swiper-slide-active');

    if (!active) {
      active = slides.find((slide) => {
        const style = window.getComputedStyle(slide);
        return style.opacity !== '0' && slide.getAttribute('aria-hidden') !== 'true';
      });
    }

    return active || slides[0];
  }

  function getNextButton() {
    return (
      heroCarousel.querySelector('.swiper-button-next') ||
      heroCarousel.querySelector('.media-carousel__arrow--next') ||
      heroCarousel.querySelector('.slider-button--next') ||
      heroCarousel.querySelector('[aria-label="Next slide"]') ||
      heroCarousel.querySelector('[aria-label*="Next"]') ||
      heroCarousel.querySelector('[aria-label*="次"]')
    );
  }
  function goToNextSlide() {
  const swiperInstance =
    heroCarousel.swiper ||
    heroCarousel.querySelector('.swiper')?.swiper ||
    heroCarousel.querySelector('[class*="swiper"]')?.swiper;



  if (swiperInstance && typeof swiperInstance.slideNext === 'function') {
    swiperInstance.slideNext();
    return true;
  }

  const nextButton =
    heroCarousel.querySelector('.swiper-button-next') ||
    heroCarousel.querySelector('.media-carousel__arrow--next') ||
    heroCarousel.querySelector('.slider-button--next') ||
    heroCarousel.querySelector('[aria-label="Next slide"]') ||
    heroCarousel.querySelector('[aria-label*="Next"]') ||
    heroCarousel.querySelector('[aria-label*="次"]');



  if (nextButton) {
    nextButton.click();
    return true;
  }

  return false;
}

  function scheduleNext() {
    clearTimeout(timer);

    const activeSlide = getActiveSlide();
 

    if (!activeSlide) return;

    const video = activeSlide.querySelector('video');
    const delay = video ? 26000 : 4000;

    

    if (video) {
      try {
        video.currentTime = 0;
        video.play().catch(() => {});
      } catch (e) {

      }
    }

  timer = setTimeout(() => {
  　const moved = goToNextSlide();

  }, delay);
  }

  const observer = new MutationObserver(() => {
    scheduleNext();
  });

  observer.observe(heroCarousel, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden']
  });

  scheduleNext();
});

function replaceReviewerName() {
  const candidates = document.querySelectorAll(
    '.jdgm-review-card__name, .jm-reviewer-info__name, .jdgm-rev__author, [title="匿名"], [title="匿"], [title="匿名."], [title="匿."]'
  );

  candidates.forEach(function(el) {
    const text = (el.textContent || '').trim();
    const title = (el.getAttribute('title') || '').trim();

    const isAnonymous =
      text === '匿名' ||
      text === '匿' ||
      text === '匿名.' ||
      text === '匿.' ||
      text === 'Anonymous' ||
      text === 'Anonymous.' ||
      title === '匿名' ||
      title === '匿' ||
      title === '匿名.' ||
      title === '匿.' ||
      title === 'Anonymous' ||
      title === 'Anonymous.';

    if (isAnonymous) {
      el.textContent = 'ご購入者様';

      if (el.hasAttribute('title')) {
        el.setAttribute('title', 'ご購入者様');
      }
    }
  });
}

function startReviewerNameReplacement() {
  replaceReviewerName();

  const observer = new MutationObserver(() => {
    replaceReviewerName();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  });

  let count = 0;
  const interval = setInterval(() => {
    replaceReviewerName();
    count += 1;
    if (count >= 20) clearInterval(interval);
  }, 800);
}

document.addEventListener('DOMContentLoaded', startReviewerNameReplacement);
window.addEventListener('load', replaceReviewerName);
